export enum SocketSessionError {
  BadRequest = 'Bad Request',
  AccessDenied = 'Access Denied',
  /** The user's access token is missing or expired; the client can refresh it and reconnect. */
  AuthExpired = 'Auth Expired',
  UnableToReachServer = 'Unable To Reach Server',
  UnexpectedError = 'Unexpected Error'
}
